import { Component } from "react";

import "./MKLoader.scss";

export default class MKLoader extends Component {
  constructor(props) {
    super(props);
    this.state = { show: this.props.show };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });
  }

  handleClick() {
    this.setState({ show: false });
  }

  render() {
    if (!this.state.show) {
      return <div>{this.props.children}</div>;
    }

    let text = this.props.message ? this.props.message : "Laddar...";

    return (
      <div className="mkContainer">
        <div className="box" onClick={this.handleClick.bind(this)}>
          {text}
        </div>
      </div>
    );
  }
}
